export const TabbarIconStyle = {
  fontSize: 30,
}
